<template>
  <div class="main-chapter1">
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 13
    </div>
    <div class="chapter-title">Журнал выполнения монтажных соединений на болтах с контролируемым натяжением</div>
    <n-items v-if="project">
      <n-input title="Наименование организации, выполняющей работы" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Наименование объекта строительства" v-bind="$form.input('projectTitle')" :text="!editable" />
      <n-input title="Должность, фамилия, инициалы и подпись лица, ответственного за выполнение работ и ведение журнала" v-bind="$form.input('responsibleWork')" :text="!editable" />
      <n-input title="Организация, разработавшая проектную документацию, чертежи КМ" v-bind="$form.input('projectorDoc')" :text="!editable" />
      <n-input title="Шифр проекта" v-bind="$form.input('cipherProject1')" :text="!editable" />
      <n-input title="Организация, разработавшая проект производства работ" v-bind="$form.input('projectorWork')" :text="!editable" />
      <n-input title="Шифр проекта" v-bind="$form.input('cipherProject2')" :text="!editable" />
      <n-input title="Предприятие, разработавшее чертежи КМД и изготовившее конструкции" v-bind="$form.input('dealer')" :text="!editable" />
      <n-input title="Шифр заказа" v-bind="$form.input('cipherOrder')" :text="!editable" />
      <n-input title="Заказчик (организация), должность, фамилия, инициалы и подпись руководителя (представителя) технического надзора" v-bind="$form.input('tech')" :text="!editable" />
      <n-input title="Журнал начат" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="Журнал окончен" v-bind="$form.input('endedAt')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
